export default __webpack_public_path__ + "61c71a28dc3b6b5ef129d716c331e940.png";